import { languages } from 'monaco-editor-core';

export const config: languages.LanguageConfiguration = {
  brackets: [
    ['{', '}'],
    ['[', ']'],
    ['(', ')'],
  ],
  autoClosingPairs: [
    { open: '{', close: '}' },
    { open: '[', close: ']' },
    { open: '(', close: ')' },
    { open: '"', close: '"' },
  ],
  surroundingPairs: [
    { open: '{', close: '}' },
    { open: '[', close: ']' },
    { open: '(', close: ')' },
    { open: '"', close: '"' },
  ],
};

/**
 * Grammar obtained from:
 * https://github.com/CERT-Polska/mquery/blob/341528170574a260f3f4eae8dde5c87bbbd480ae/src/mqueryfront/src/query/yara-lang.js
 */
export const grammar = <languages.IMonarchLanguage>{
  defaultToken: 'invalid',

  keywords: [
    'import',
    'include',
    'rule',
    'meta',
    'strings',
    'condition',
    'global',
    'private',
    'ascii',
    'nocase',
    'wide',
    'xor',
    'fullword',
    'all',
    'any',
    'at',
    'contains',
    'entrypoint',
    'false',
    'filesize',
    'for',
    'in',
    'matches',
    'of',
    'them',
    'true',
    'and',
    'or',
    'not',
    'base64',
    'base64wide',
    'endswith',
    'icontains',
    'iendswith',
    'iequals',
    'istartswith',
    'none',
    'startswith',
    'defined',
  ],

  typeKeywords: [
    'int8',
    'int16',
    'int32',
    'int8be',
    'int16be',
    'int32be',
    'uint8',
    'uint16',
    'uint32',
    'uint8be',
    'uint16be',
    'uint32be',
  ],

  operators: [
    '=',
    '>',
    '<',
    '!',
    '~',
    '?',
    ':',
    '==',
    '<=',
    '>=',
    '!=',
    '&&',
    '||',
    '++',
    '--',
    '+',
    '-',
    '*',
    '/',
    '&',
    '|',
    '^',
    '%',
    '<<',
    '>>',
    '>>>',
    '+=',
    '-=',
    '*=',
    '/=',
    '&=',
    '|=',
    '^=',
    '%=',
    '<<=',
    '>>=',
    '>>>=',
  ],

  symbols: /[=><!~?:&|+\-*/^%]+/,
  escapes: /\\(?:[abfnrtv\\""]|x[0-9A-Fa-f]{1,4}|u[0-9A-Fa-f]{4}|U[0-9A-Fa-f]{8})/,

  // The main tokenizer for our languages
  tokenizer: {
    root: [
      // identifiers and keywords
      [
        /[a-z_$][\w$]*/,
        {
          cases: {
            '@keywords': 'keyword',
            '@typeKeywords': 'keyword.type',
            '@default': 'identifier',
          },
        },
      ],
      [/[A-Z][\w$]*/, 'type.identifier'], // to show class names nicely

      // whitespace
      { include: '@whitespace' },

      // delimiters and operators
      [/[{}()[\]]/, '@brackets'],
      [/[<>](?!@symbols)/, '@brackets'],

      [
        /@symbols/,
        {
          cases: {
            '@operators': 'operator',
            '@default': '',
          },
        },
      ],

      [/#!?[[^]*\]/, 'annotation'],
      [/#!?.*$/, 'annotation.invalid'],

      // numbers
      [/\d*\.\d+([eE][-+]?\d+)?[fFdD]?/, 'number.float'],
      [/0[xX][0-9a-fA-F_]*[0-9a-fA-F][Ll]?/, 'number.hex'],
      [/0[0-7_]*[0-7][Ll]?/, 'number.octal'],
      [/0[bB][0-1_]*[0-1][Ll]?/, 'number.binary'],
      [/\d+[lL]?/, 'number'],

      // delimiter: after number because of .\d floats
      [/[;,.]/, 'delimiter'],

      // strings
      [/"([^"\\]|\\.)*$/, 'string.invalid'], // non-teminated string
      [/"/, 'string', '@string'],

      // characters
      [/"[^\\"]"/, 'string'],
      [/(")(@escapes)(")/, ['string', 'string.escape', 'string']],
      [/"/, 'string.invalid'],
    ],

    whitespace: [
      [/[ \t\r\n]+/, 'white'],
      [/\/\*/, 'comment', '@comment'],
      [/\/\/.*$/, 'comment'],
    ],

    comment: [
      [/[^/*]+/, 'comment'],
      [/\/\*/, 'comment', '@push'],
      [/\/\*/, 'comment.invalid'],
      ['\\*/', 'comment', '@pop'],
      [/[/*]/, 'comment'],
    ],

    string: [
      [/[^\\"]+/, 'string'],
      [/@escapes/, 'string.escape'],
      [/\\./, 'string.escape.invalid'],
      [/"/, 'string', '@pop'],
    ],
  },
};
